export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      var tmp = pair[1].split("%");
      var value = "";
      for (let index = 0; index < tmp.length; index++) {
        if (index === 0) {
          value = value + tmp[index];
        } else if (tmp[index]) {
          value = value + "%" + tmp[index];
        }
      }
      return value;
    }
  }
  return "";
}

export function encodePacent(str) {
  var tmp = str.split("%");
  var value = "";
  for (let index = 0; index < tmp.length; index++) {
    if (index === 0) {
      value = value + tmp[index];
    } else if (tmp[index]) {
      value = value + "%" + tmp[index];
    }
  }
  return value;
}

export function isObjectValueEqual(a, b) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  if (aProps.length != bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    var propA = a[propName];
    var propB = b[propName];
    if (typeof propA === "object") {
      // if (this.isObjectValueEqual(propA, propB)) {
      //   return true;
      // } else {
      //   return false;
      // }
    } else if (propA !== propB) {
      return false;
    } else {
    }
  }
  return true;
}

export function formateDate(timestamp) {
  var date = new Date(timestamp);
  var y = 1900 + date.getYear();
  var m = "0" + (date.getMonth() + 1);
  var d = "0" + date.getDate();
  return (
    y +
    "年" +
    m.substring(m.length - 2, m.length) +
    "月" +
    d.substring(d.length - 2, d.length) +
    "日"
  );
}

export function formateDateSlash(timestamp) {
  var date = new Date(timestamp);
  var y = 1900 + date.getYear();
  var m = "0" + (date.getMonth() + 1);
  var d = "0" + date.getDate();
  return (
    y +
    "/" +
    m.substring(m.length - 2, m.length) +
    "/" +
    d.substring(d.length - 2, d.length)
  );
}

export function getLocations(websiteid){
  switch (websiteid) {
    case ("1"):
        return {name:"泰州市政府门户网站", url:"www.taizhou.gov.cn"};
        break;
    case ("107"):
        return {name:"泰州市政府门户网站", url:"zwgk.taizhou.gov.cn"};
        break;
    case ("124"):
        return {name:"泰兴市", url:"www.taixing.gov.cn"};
        break;
    case ("115"):
        return {name:"兴化市", url:"www.xinghua.gov.cn"};
        break;
    case ("113"):
        return {name:"海陵区", url:"www.tzhl.gov.cn"};
        break;
    case ("123"):
        return {name:"高港区", url:"www.gaogang.gov.cn"};
        break;
    case ("122"):
        return {name:"姜堰区", url:"www.jiangyan.gov.cn"};
        break;
    case ("143"):
        return {name:"靖江市", url:"www.jingjiang.gov.cn"};
        break;
    case ("4"):
        return {name:"市文广旅局", url:"wgl.taizhou.gov.cn"};
        break;
    case ("6"):
        return {name:"English-taizhou", url:"english.taizhou.gov.cn"};
        break;
    case ("8"):
        return {name:"市机关事务管理局", url:"jgglj.taizhou.gov.cn"};
        break;
    case ("9"):
        return {name:"市统计局", url:"tjj.taizhou.gov.cn"};
        break;
    case ("10"):
        return {name:"市民政局", url:"mzj.taizhou.gov.cn"};
        break;
    case ("15"):
        return {name:"市卫健委", url:"wjw.taizhou.gov.cn"};
        break;
    case ("16"):
        return {name:"市党史方志办", url:"szb.taizhou.gov.cn"};
        break;
    case ("17"):
        return {name:"市司法局", url:"sfj.taizhou.gov.cn"};
        break;
    case ("20"):
        return {name:"市审计局", url:"sjj.taizhou.gov.cn"};
        break;
    case ("21"):
        return {name:"市民宗局", url:"zjswj.taizhou.gov.cn"};
        break;
    case ("22"):
        return {name:"市体育局", url:"tyj.taizhou.gov.cn"};
        break;
    case ("23"):
        return {name:"市水利局", url:"slj.taizhou.gov.cn"};
        break;
    case ("24"):
        return {name:"市民防局", url:""};
        break;
    case ("26"):
        return {name:"市科技局", url:"kjj.taizhou.gov.cn"};
        break;
    case ("27"):
        return {name:"市生态环境局", url:"hbj.taizhou.gov.cn"};
        break;
    case ("28"):
        return {name:"市发改委", url:"fgw.taizhou.gov.cn"};
        break;
    case ("30"):
        return {name:"市城管局", url:"cgj.taizhou.gov.cn"};
        break;
    case ("31"):
        return {name:"市信访局", url:"xfj.taizhou.gov.cn"};
        break;
    case ("35"):
        return {name:"医药高新区", url:"tzgxq.taizhou.gov.cn"};
        break;
    case ("56"):
        return {name:"泰州调查队", url:"tzdcd.taizhou.gov.cn"};
        break;
    case ("57"):
        return {name:"市教育局", url:"jyj.taizhou.gov.cn"};
        break;
    case ("61"):
        return {name:"市市场监督管理局", url:"scjgj.taizhou.gov.cn"};
        break;
    case ("66"):
        return {name:"市行政审批局", url:"zwfw.taizhou.gov.cn"};
        break;
    case ("67"):
        return {name:"市应急管理局", url:"yjj.taizhou.gov.cn"};
        break;
    case ("68"):
        return {name:"泰州人大", url:""};
        break;
    case ("69"):
        return {name:"市财政局", url:"czj.taizhou.gov.cn"};
        break;
    case ("73"):
        return {name:"市商务局", url:"swj.taizhou.gov.cn"};
        break;
    case ("75"):
        return {name:"市交通运输局", url:"jtysj.taizhou.gov.cn"};
        break;
    case ("83"):
        return {name:"市政协网", url:""};
        break;
    case ("84"):
        return {name:"市公积金中心", url:"gjj.taizhou.gov.cn"};
        break;
    case ("87"):
        return {name:"市工信局", url:"gxj.taizhou.gov.cn"};
        break;
    case ("90"):
        return {name:"法院", url:""};
        break;
    case ("91"):
        return {name:"高新区信息公开站", url:"gxqxxgk.taizhou.gov.cn"};
        break;
    case ("92"):
        return {name:"市农业农村局", url:"nyncj.taizhou.gov.cn"};
        break;
    case ("95"):
        return {name:"市人社局", url:"rsj.taizhou.gov.cn"};
        break;
    case ("96"):
        return {name:"市住建局", url:"jsj.taizhou.gov.cn"};
        break;
    case ("99"):
        return {name:"信用泰州", url:"tzcredit.taizhou.gov.cn"};
        break;
    case ("103"):
        return {name:"市公安局", url:"gaj.taizhou.gov.cn"};
        break;
    case ("104"):
        return {name:"市供销合作总社", url:"tzgxzs.taizhou.gov.cn"};
        break;
    case ("105"):
        return {name:"农业开发区", url:"nykfq.taizhou.gov.cn"};
        break;
    default:
        return {name:"", url:""};
        break;
}
}